import styled from 'styled-components';
export const Root = styled.div `
  display: grid;
  justify-items: center;
  margin: 0 auto;
  max-width: 650px;
  padding: 2rem 1rem;
`;
//# sourceMappingURL=UiAddToSlackSection.styles.js.map